import React from "react";
import { connect } from "react-redux";
import { getTranslate } from "react-localize-redux";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Select from "react-select";

function NewComerModal({
  translate,
  modalNewComer,
  timeZone,
  tzOptions,
  handleChangeTimeZone,
  language,
  handleLanguageChange,
  handleNewComerOKClick,
}) {
  return (
    <Modal isOpen={modalNewComer}>
      <ModalHeader>
        {translate("Welcome to Posti Messaging Track & Trace")}
      </ModalHeader>
      <ModalBody>
        <div className="form-group" style={{ height: "54px" }}>
          <label className="cols-sm-2 control-label">
            {translate("Please choose your time zone:")}
          </label>
          <Select
            name="timeZoneId"
            clearable={false}
            value={timeZone}
            onChange={handleChangeTimeZone}
            options={tzOptions}
          />
        </div>
        <div
          className="form-group"
          style={{ height: "54px", marginTop: "1.5em" }}
        >
          <label className="cols-sm-2 control-label">
            {translate("Please choose language:")}
          </label>
          <Select
            name="languageId"
            clearable={false}
            value={language}
            onChange={handleLanguageChange}
            options={[
              { value: "en-GB", label: "English (UK)" },
              { value: "fi", label: "Finnish" },
              { value: "no", label: "Norwegian" },
              { value: "sv", label: "Swedish" },
            ]}
          />
        </div>
        <br />
        <div>
          <span className="info-msg">
            * {translate("You can always change settings by pressing")}{" "}
            <span className="fa fa-cog" /> {translate("on the top-bar.")}
          </span>
        </div>
      </ModalBody>
      <ModalFooter className="text-center">
        <button
          style={{ width: "150px" }}
          type="button"
          className="btn btn-primary"
          onClick={handleNewComerOKClick}
        >
          {translate("Close")}
        </button>
      </ModalFooter>
    </Modal>
  );
}

function mapStateToProps(state) {
  const { locale } = state;
  return {
    translate: getTranslate(locale),
  };
}

const connectedNewComerModal = connect(mapStateToProps)(NewComerModal);
export { connectedNewComerModal as NewComerModal };
